export const PAGE_SIZE = 20;
// Import stages from centralized configuration
export { RECRUITMENT_STAGES as STAGES } from "../../config/stages";